<template>
  <div class="wrapper">
    <div class="login-card">
      <div class="login-card-header">
        <img
          :src="require(`@/assets/logos/booracolorido.png`)"
          alt="pickndrive"
          style="width: 120px; margin: 20%"
        />
      </div>
      <form @submit.prevent="changePassword">
        <div class="form-group">
          <label for="password-input">Senha</label>
          <input
            type="password"
            v-model="password"
            id="password-input"
            class="form-control"
            placeholder="Sua nova senha"
            aria-label="Sua nova senha"
            aria-describedby="basic-addon2"
          />
        </div>
        <div class="form-group">
          <label for="confirmPassword-input">Confirmar Senha</label>
          <input
            type="password"
            v-model="confirmPassword"
            id="confirmPassword-input"
            class="form-control"
            placeholder="Confirme sua senha"
            aria-label="Confirme sua senha"
            aria-describedby="basic-addon2"
          />
        </div>
        <button type="submit" class="btn btn-block">Solicitar o reset</button>
      </form>
    </div>
  </div>
</template>

<script>
import AuthController from '../../controllers/AuthController.js';

export default {
  data() {
    return {
      email: null,
      password: null,
      confirmPassword: null,
    };
  },

  created() {
    this.authController = new AuthController(
      this.$resource,
      this.$router,
      this.$message
    );
    const email = this.$route.params.email;
    const token = this.$route.params.token;

    this.authController.accessResetPassword(email, token);
  },

  methods: {
    changePassword() {
      if (this.password === this.confirmPassword) {
        this.authController.changePassword(this.password).then(() => {
          this.$message({
            message: 'Senha alterada com sucesso!',
            type: 'success',
          });
          setTimeout(() => this.$router.push({ name: 'Login' }), 2000);
        });
      } else {
        this.$message({
          message: 'As senhas informadas não são iguais!',
          type: 'error',
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  position: fixed;
  width: 100vw;
  height: 100%;
  background: url('../../assets/background-desktop.png');
  background-size: cover;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  // justify-content: center;
  align-items: center;
  @media (max-width: 560px) {
    overflow: scroll;
    padding-bottom: 150px;
  }
}

.wrapper .login-card {
  border-radius: 3px;
  padding: 15px 25px;
  // height: 100px;
  width: 400px;
  @media (max-width: 600px) {
    width: 80%;
  }
}

.login-card label {
  color: gray;
}

.login-card .change-visibility-span:hover {
  cursor: pointer;
}

.login-card .login-card-header {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  img {
    width: 100%;
    height: 100%;
  }
}

.forgot-password {
  display: flex;
  justify-content: flex-end;
  margin: 20px 0px;
}

footer {
  margin-top: 20px;
  color: #979797;
  max-width: 400px;
  font-size: 9px;
  @media (max-width: 560px) {
    width: 80%;
  }
}

.btn {
  background: var(--primary-color) !important;
  font-weight: bold;
}
</style>
